import React, { Component } from "react";
import { Modal, Button, Icon, Tooltip, Switch } from "antd";
import Cattag from "./Cattag";
import axios from "axios";
import "./styles.css";

class Popup extends Component {
  constructor(props) {
    super(props);
    this.state = {
      visible: false,
      dataSource: [],
      special: [],
      basic: [],
      rare: [],
      superRare: [],
      uberSuperRare: [],
      legendaryRare: [],
      checked: [
        {
          special: false,
          basic: false,
          rare: false,
          superRare: false,
          uberSuperRare: false,
          legendaryRare: false
        }
      ]
    };
  }

  showModal = () => {
    this.setState({
      visible: true
    });
  };

  handleOk = () => {
    // console.log(e);
    let statecopy = this.state;
    let raritylist = [
      "special",
      "basic",
      "rare",
      "superRare",
      "uberSuperRare",
      "legendaryRare"
    ];
    let finalcatlist = [];
    for (var i = 0; i < raritylist.length; i++) {
      finalcatlist.push(statecopy[raritylist[i]]);
    }
    finalcatlist = finalcatlist.reduce((r, c) => Object.assign(r, c), {});
    finalcatlist = Object.keys(finalcatlist).filter(function(key) {
      return finalcatlist[key];
    });

    let datasourcecopy = this.state.dataSource;

    function filterByName(item) {
      if (finalcatlist.includes(item.name)) {
        return true;
      }
      return false;
    }
    //filters only cats which are in the finalcatlist array from the datasourcecopy
    let finalselectedcats = datasourcecopy.filter(filterByName);
    this.props.callbackFromParent(finalselectedcats);

    this.setState({
      visible: false
    });
  };

  handleCancel = () => {
    this.setState({
      visible: false
    });
  };

  onSwitchChange = rarity => {
    let selectAll = this.state.checked[rarity] ? false : true;
    let currentChecked = this.state.checked;
    currentChecked[rarity] = selectAll;
    this.setState(prevState => ({
      [rarity]: Object.keys(prevState[rarity]).reduce(
        (reduced, key) => ({
          ...reduced,
          [key]: selectAll
        }),
        {}
      ),
      checked: currentChecked
    }));
  };

  myCallbackToCattag = (rarity, catname) => {
    let catlist = this.state[rarity];
    catlist[catname] = !catlist[catname];
    this.setState({ [rarity]: catlist });
  };

  componentWillMount() {
    axios
      .get("https://onestoppress.com/api/allcats")
      .then(res => {
        let dataSource = res.data.sampledata.filter(
          cat => cat.number.slice(3) === "-1"
        );
        this.setState({ dataSource: dataSource });
      })
      .then(res => {
        // var rarity = "basic";
        // var catname = "Tank Cat";
        this.setState({
          special: this.state.dataSource
            .filter(cat => cat.rarity === "Special")
            .map(function(cat) {
              let name = cat.name.toString();
              return { [name]: false };
            })
            .reduce((r, c) => Object.assign(r, c), {})
        });
        this.setState(
          {
            basic: this.state.dataSource
              .filter(cat => cat.rarity === "Basic")
              .map(function(cat) {
                let name = cat.name.toString();
                return { [name]: false };
              })
              .reduce((r, c) => Object.assign(r, c), {})
          },
          function() {
            // console.log(this.state[rarity][catname]);
          }
        );
        this.setState({
          rare: this.state.dataSource
            .filter(cat => cat.rarity === "Rare")
            .map(function(cat) {
              let name = cat.name.toString();
              return { [name]: false };
            })
            .reduce((r, c) => Object.assign(r, c), {})
        });
        this.setState({
          superRare: this.state.dataSource
            .filter(cat => cat.rarity === "Super Rare")
            .map(function(cat) {
              let name = cat.name.toString();
              return { [name]: false };
            })
            .reduce((r, c) => Object.assign(r, c), {})
        });
        this.setState({
          uberSuperRare: this.state.dataSource
            .filter(cat => cat.rarity === "Uber Super Rare")
            .map(function(cat) {
              let name = cat.name.toString();
              return { [name]: false };
            })
            .reduce((r, c) => Object.assign(r, c), {})
        });
        this.setState({
          legendaryRare: this.state.dataSource
            .filter(cat => cat.rarity === "Legendary Rare")
            .map(function(cat) {
              let name = cat.name.toString();
              return { [name]: false };
            })
            .reduce((r, c) => Object.assign(r, c), {})
        });
      });
  }

  getCatTags(rarity) {
    const { dataSource } = this.state;
    let dataSourceCopy = dataSource.filter(cat => cat.rarity === rarity);
    let getCatTagResults = [];
    dataSourceCopy.forEach(cat => {
      let catname = cat.name;
      let temprarity = cat.rarity.charAt(0).toLowerCase() + cat.rarity.slice(1);
      let staterarity = temprarity.replace(/\s/g, "");
      //   console.log(rarity);
      getCatTagResults.push(
        <Cattag
          className="cattag"
          rarity={staterarity}
          catname={catname}
          checked={this.state[staterarity][catname]}
          callbackFromModal={this.myCallbackToCattag.bind(this)}
        >
          <img
            src={"https://onestoppress.com/images/" + cat.number + ".png"}
            alt={catname}
            style={{ float: "left" }}
          />
          <span
            style={{
              whiteSpace: "normal",
              display: "inline-block",
              width: "100px",
              padding: "0px 2px 0px 4px",
              lineHeight: "15px",
              fontSize: "12px",
              wordBreak: "break-word",
              overflowWrap: "break-word",
              textAlign: "left",
              verticalAlign: "-webkit-baseline-middle"
            }}
          >
            {cat.name}
          </span>
        </Cattag>
      );
    });
    return getCatTagResults;
  }

  render() {
    return (
      <div>
        <Tooltip placement="topRight" title="Add multiple">
          <Button
            onClick={this.showModal}
            style={{
              float: "right",
              marginLeft: "4px",
              padding: "4px"
            }}
          >
            <Icon style={{ padding: "0px" }} type="plus" />
          </Button>
        </Tooltip>
        <Modal
          title="Select Multiple Cats"
          visible={this.state.visible}
          onOk={this.handleOk}
          onCancel={this.handleCancel}
          style={{ top: "36px" }}
          centered
        >
          <h4>
            Special
            <div style={{ float: "right" }}>
              <div
                style={{
                  display: "inline-block",
                  padding: "2px",
                  fontWeight: "200",
                  fontSize: "13px"
                }}
              >
                {this.state.checked.special ? "Deselect All" : "Select All"}
              </div>
              <Switch
                size="small"
                defaultChecked
                checked={this.state.checked.special}
                onChange={() => this.onSwitchChange("special")}
              />
            </div>
            <hr style={{ marginTop: "2px" }} />
          </h4>
          <div>{this.getCatTags("Special")}</div>
          <h4 style={{ paddingTop: "18px" }}>
            Basic{" "}
            <div style={{ float: "right" }}>
              <div
                style={{
                  display: "inline-block",
                  padding: "2px",
                  fontWeight: "200",
                  fontSize: "13px"
                }}
              >
                {this.state.checked.basic ? "Deselect All" : "Select All"}
              </div>
              <Switch
                size="small"
                defaultChecked
                checked={this.state.checked.basic}
                onChange={() => this.onSwitchChange("basic")}
              />
            </div>
            <hr style={{ marginTop: "2px" }} />
          </h4>
          <div>{this.getCatTags("Basic")}</div>
          <h4 style={{ paddingTop: "18px" }}>
            Rare{" "}
            <div style={{ float: "right" }}>
              <div
                style={{
                  display: "inline-block",
                  padding: "2px",
                  fontWeight: "200",
                  fontSize: "13px"
                }}
              >
                {this.state.checked.rare ? "Deselect All" : "Select All"}
              </div>
              <Switch
                size="small"
                defaultChecked
                checked={this.state.checked.rare}
                onChange={() => this.onSwitchChange("rare")}
              />
            </div>
            <hr style={{ marginTop: "2px" }} />
          </h4>
          <div>{this.getCatTags("Rare")}</div>
          <h4 style={{ paddingTop: "18px" }}>
            Super Rare{" "}
            <div style={{ float: "right" }}>
              <div
                style={{
                  display: "inline-block",
                  padding: "2px",
                  fontWeight: "200",
                  fontSize: "13px"
                }}
              >
                {this.state.checked.superRare ? "Deselect All" : "Select All"}
              </div>
              <Switch
                size="small"
                defaultChecked
                checked={this.state.checked.superRare}
                onChange={() => this.onSwitchChange("superRare")}
              />
            </div>
            <hr style={{ marginTop: "2px" }} />
          </h4>
          <div>{this.getCatTags("Super Rare")}</div>
          <h4 style={{ paddingTop: "18px" }}>
            Uber Super Rare{" "}
            <div style={{ float: "right" }}>
              <div
                style={{
                  display: "inline-block",
                  padding: "2px",
                  fontWeight: "200",
                  fontSize: "13px"
                }}
              >
                {this.state.checked.uberSuperRare
                  ? "Deselect All"
                  : "Select All"}
              </div>
              <Switch
                size="small"
                defaultChecked
                checked={this.state.checked.uberSuperRare}
                onChange={() => this.onSwitchChange("uberSuperRare")}
              />
            </div>
            <hr style={{ marginTop: "2px" }} />
          </h4>
          <div>{this.getCatTags("Uber Super Rare")}</div>
          <h4 style={{ paddingTop: "18px" }}>
            Legendary Rare{" "}
            <div style={{ float: "right" }}>
              <div
                style={{
                  display: "inline-block",
                  padding: "2px",
                  fontWeight: "200",
                  fontSize: "13px"
                }}
              >
                {this.state.checked.legendaryRare
                  ? "Deselect All"
                  : "Select All"}
              </div>
              <Switch
                size="small"
                defaultChecked
                checked={this.state.checked.legendaryRare}
                onChange={() => this.onSwitchChange("legendaryRare")}
              />
            </div>
            <hr style={{ marginTop: "2px" }} />
          </h4>
          <div>{this.getCatTags("Legendary Rare")}</div>
        </Modal>
      </div>
    );
  }
}

export default Popup;



// WEBPACK FOOTER //
// ./src/components/multiplecats/Modal.js